import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import GrowthKpiRunChart from './GrowthKpiRunChart';

const GrowthKpiSection = ({ projectId, project }) => {
  return (
    <div className="mb-4">
      <Card className="border-0 shadow-sm">
        <Card.Header className="bg-transparent border-0 pt-4 px-4 pb-0">
          <h5 className="mb-0">
            <FontAwesomeIcon icon={faChartLine} className="me-2 text-success" />
            Growth KPI Run Chart
          </h5>
          <p className="text-muted mb-0 mt-1" style={{ fontSize: '0.85rem' }}>
            Tracks completed action items and reports over time. Points are colored by event type;
            purple bands highlight coordinated improvement clusters.
          </p>
        </Card.Header>
        <Card.Body className="px-4 pt-3">
          <GrowthKpiRunChart
            projectId={projectId}
            projectStartDate={project?.startDate}
            projectEndDate={project?.endDate}
          />
        </Card.Body>
      </Card>
    </div>
  );
};

export default GrowthKpiSection;
